import React, { useState, useRef, useEffect } from 'react';
import { formatarMoeda, formatarPercentual } from '../../utils/formatters';

const CardFaturamento = ({ dados, loading, textoComparacao = 'vs. período anterior', descricaoProjecao = 'Projeção = (Valor Atual / Dias Corridos) x Dias Totais do Mês.', descricaoMesAnterior = 'Valor de faturamento do período anterior.' }) => {
  const [popupProjecaoAberto, setPopupProjecaoAberto] = useState(false);
  const [popupMesAnteriorAberto, setPopupMesAnteriorAberto] = useState(false);
  const popupProjecaoRef = useRef(null);
  const buttonProjecaoRef = useRef(null);
  const popupMesAnteriorRef = useRef(null);
  const buttonMesAnteriorRef = useRef(null);

  // Fechar popup de projeção ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popupProjecaoRef.current && 
        !popupProjecaoRef.current.contains(event.target) &&
        buttonProjecaoRef.current &&
        !buttonProjecaoRef.current.contains(event.target)
      ) {
        setPopupProjecaoAberto(false);
      }
    };

    if (popupProjecaoAberto) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [popupProjecaoAberto]);

  // Fechar popup de mês anterior ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popupMesAnteriorRef.current && 
        !popupMesAnteriorRef.current.contains(event.target) &&
        buttonMesAnteriorRef.current &&
        !buttonMesAnteriorRef.current.contains(event.target)
      ) {
        setPopupMesAnteriorAberto(false);
      }
    };

    if (popupMesAnteriorAberto) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [popupMesAnteriorAberto]);
  return (
    <div className="kpi-card">
      {/* Header */}
      <div className="kpi-card-header">
        <div className="flex items-center" style={{ gap: 'var(--space-fluid-xs)' }}>
          <div className="kpi-card-icon bg-blue-500">
            <img src="icons/valor-real.png" alt="Icone Real" />
          </div>
          <h3 className="kpi-card-title">Faturamento</h3>
        </div>
        {/* Badge de Tendência no Header - Canto Superior Direito */}
        {!loading && dados.percentualCrescimento !== null && (
          <div className={`kpi-card-badge ${dados.percentualCrescimento >= 0
              ? 'bg-green-50 border border-green-200' 
              : 'bg-red-50 border border-red-200'
            }`}>
            <span className={`kpi-card-badge-text ${dados.percentualCrescimento >= 0 ? 'text-green-600' : 'text-red-600'}`}>
              {dados.percentualCrescimento >= 0 ? '▲' : '▼'}
            </span>
            <span className="kpi-card-badge-text text-gray-800">
              {formatarPercentual(dados.percentualCrescimento)}
            </span>
          </div>
        )}
        {loading && (
          <div className="bg-gray-200 animate-pulse rounded-full" style={{ height: 'var(--icon-fluid-sm)', width: 'calc(var(--icon-fluid-md) * 2)' }}></div>
        )}
      </div>

      {/* Valor Principal */}
      <div className="kpi-card-value">
        {loading ? (
          <div className="bg-gray-200 animate-pulse rounded" style={{ height: 'var(--icon-fluid-lg)' }}></div>
        ) : (
          formatarMoeda(dados.valorTotal)
        )}
      </div>

      {/* Projeção */}
      {dados.projecao !== null && (
        <div className="relative" style={{ marginBottom: 'var(--space-fluid-xs)' }}>
          {loading ? (
            <div className="bg-gray-200 animate-pulse rounded w-2/3" style={{ height: 'var(--icon-fluid-sm)' }}></div>
          ) : (
            <>
              <div className="kpi-card-secondary">
                  <button
                    ref={buttonProjecaoRef}
                    type="button"
                    onClick={() => setPopupProjecaoAberto(!popupProjecaoAberto)}
                  className="kpi-card-info-btn"
                    aria-label="Mostrar descrição"
                  >
                  <img src="/icons/info.svg" alt="Info" />
                  </button>
                <span className="font-bold truncate">{formatarMoeda(dados.projecao)}</span>
                <span className="kpi-card-secondary-label">em projeção</span>
                </div>
              {popupProjecaoAberto && (
                <div ref={popupProjecaoRef} className="absolute top-full left-0 right-0 mt-2 z-50">
                  <div className="bg-gray-700 text-white rounded-lg shadow-lg w-full whitespace-normal" style={{ fontSize: 'var(--text-fluid-xs)', padding: 'var(--space-fluid-xs) var(--space-fluid-sm)' }}>
                    {descricaoProjecao}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      )}

      {/* Mês Anterior - Sempre exibido */}
      <div className="relative">
        {loading ? (
          <div className="bg-gray-200 animate-pulse rounded w-2/3" style={{ height: 'var(--icon-fluid-sm)' }}></div>
        ) : (
          <>
            <div className="kpi-card-secondary">
                <button
                  ref={buttonMesAnteriorRef}
                  type="button"
                  onClick={() => setPopupMesAnteriorAberto(!popupMesAnteriorAberto)}
                className="kpi-card-info-btn"
                  aria-label="Mostrar descrição"
                >
                <img src="/icons/info.svg" alt="Info" />
                </button>
              <span className="font-bold truncate">
                {formatarMoeda(dados.valorAnterior !== null ? dados.valorAnterior : 0)} 
              </span>
              <span className="kpi-card-secondary-label truncate">{textoComparacao}</span>
            </div>
            {popupMesAnteriorAberto && (
              <div ref={popupMesAnteriorRef} className="absolute top-full left-0 right-0 mt-2 z-50">
                <div className="bg-gray-700 text-white rounded-lg shadow-lg w-full whitespace-normal" style={{ fontSize: 'var(--text-fluid-xs)', padding: 'var(--space-fluid-xs) var(--space-fluid-sm)' }}>
                  {descricaoMesAnterior}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default CardFaturamento;

